export default "__VITE_PUBLIC_ASSET__51bbed98__"